<template>
  <div class="content">
    <h1 class="has-text-centered">WLAN</h1>
    <div class="box">
      <p>Eine kompakte Zusammenfassung über WLAN.</p>
      <FAQsTableOfContents :faqs="faqs" />
    </div>

    <div class="box">
      <FAQs :faqs="faqs" :h_level="2" />
    </div>

    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'
import FAQs from '@/components/FAQs.vue'
import FAQsTableOfContents from '@/components/FAQsTableOfContents.vue'

export default {
  name: 'theory-wlan',
  components: {
    FeedbackBox,
    FAQs,
    FAQsTableOfContents
  },
  metaInfo: {
    title: 'WLAN | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine kompakte Zusammenfassung über WLAN.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'network-engineering' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Was ist WLAN?',
          answer:
            '<ul>' +
            '  <li>WLAN = <strong>W</strong>ireless <strong>L</strong>ocal <strong>A</strong>rea <strong>N</strong>etwork</li>' +
            '  <li>Drahtlose, lokale Netze die ihre Daten mit Funk übertragen</li>' +
            '  <li>Genutzte Frequenzbänder (werden weiters in Kanäle unterteilt)</li>' +
            '  <ul>' +
            '    <li>2,4 GHz</li>' +
            '    <li>5 GHz</li>' +
            '    <li>60 GHz</li>' +
            '  </ul>' +
            '</ul>'
        },
        {
          question: 'Welche WLAN Betriebsarten gibt es?',
          answer:
            '<h3>Infrastructure-Mode</h3>' +
            '<ul>' +
            '  <li>Eine Funkzelle</li>' +
            '  <li>Wird zentral vom WAP ( Wireless Access Point) gesteuert</li>' +
            '  <li>Stern- oder Bustopologie</li>' +
            '</ul>' +
            '<h3>Ad-Hoc-Mode</h3>' +
            '<ul>' +
            '  <li>Netz konfiguriert sich selbst - keine zentrale Komponente</li>' +
            '  <li>Besitzt keine Hierarchie</li>' +
            '  <li>Neue Kommunikationspartner werden dynamisch eingebunden</li>' +
            '  <li>Endgeräte übernehmen das Routing und speichern die Routingtabellen</li>' +
            '</ul>'
        },
        {
          question: 'Welche WLAN-Standards gibt es?',
          answer:
            '<ul>' +
            '  <li>Mehrere Standards die sich in maximaler Datenübertragungsrate und Frequenzband unterscheiden</li>' +
            '  <ul>' +
            '    <li>802.11 (a, b, h, g, n, ac, ad)</li>' +
            '  </ul>' +
            '  <li>Werden vom IEEE (Institute of Electrical and Electronics Engineers) spezifiziert und weiterentwickelt</li>' +
            '</ul>'
        },
        {
          question: 'Welche Einsatzmöglichkeiten gibt es für WLAN?',
          answer:
            '<ul>' +
            '  <li>Kabelloses WLAN an kabelgebundenes LAN anbinden</li>' +
            '  <li>Verbindung örtlich getrennter Netzwerke mithilfe einer Richtfunkstrecke</li>' +
            '</ul>'
        },
        {
          question: 'Welche Reichweite hat WLAN?',
          answer:
            '<ul>' +
            '  <li>Umgebung und daraus resultierende Funkstörungen können Reichweite beinflussen</li>' +
            '  <li>Kann durch Repeater erhöht werden</li>' +
            '</ul>'
        },
        {
          question: 'Welche Sicherheitsmechanismen gibt es in einem WLAN?',
          answer:
            '<ul>' +
            '  <li>Authentifizierung an einem WAP (<strong>W</strong>ireless <strong>A</strong>ccess <strong>P</strong>oint)</li>' +
            '  <ul>' +
            '    <li>Per Benutzername und Passwort</li>' +
            '    <li>Per Pre-shared Key&nbsp;</li>' +
            '  </ul>' +
            '  <li>Verschlüsselungsstandards</li>' +
            '  <ul>' +
            '    <li>WEP (<strong>W</strong>ired <strong>E</strong>quivalent <strong>P</strong>rivacy) - unsicherstes Verfahren</li>' +
            '    <li>WPA (<strong>W</strong>i-Fi <strong>P</strong>rotected <strong>A</strong>ccess)</li>' +
            '    <li>WPA2 (<strong>W</strong>i-Fi <strong>P</strong>rotected <strong>A</strong>ccess) - Verschlüsselung mit AES (<strong>A</strong>dvanced <strong>E</strong>ncryption <strong>S</strong>tandard)</li>' +
            '  </ul>' +
            '  <li>Typische Schwachstellen</li>' +
            '  <ul>' +
            '    <li>Default-Zugangsdaten der Verwaltungsoberfläche</li>' +
            '    <li>Unsichere Grundkonfiguration</li>' +
            '    <li>Veraltete Sicherheitsstandards</li>' +
            '  </ul>' +
            '</ul>'
        }
      ]
    }
  }
}
</script>
